const reportTheme = {
  id: 305,
  name: "pyramid",
  slug: "pyramid",
  title: null,
  description: null,
  clientID: 1,
  created_at: "2024-10-18T09:33:07.000000Z",
  updated_at: "2024-10-18T09:33:23.000000Z",
  use_for_summary: false,
  allow_for_custom: false,
  country: "England",
};

const items = [
  {
    id: 2630,
    reportThemeID: 305,
    text: null,
    chartType: "Pyramid",
    chartRef: "17292440038367",
    chartDescription: "Population By Age and Gender",
    chartXLabel: null,
    chartYLabel: null,
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 1,
    timeSeries: true,
    itemName: null,
    itemSource: null,
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    left_label: "Female",
    right_label: "Male",
    comparator: "C1",
    indicators: [
      {
        id: 7502,
        indicatorHTMLTableRef: null,
        chartRef: "17292440038367",
        indicatorCode: "mye_16_64_females*dr",
        indicatorDate: "2022-06-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1,
        y_label: "16-64",
        indicatorName: "Female population aged 16 to 64",
        source: "Office for National Statistics (ONS)",
        date: "2022-06-01",
        decimalPlaces: 2,
        dateCoverageText: "2022",
      },
      {
        id: 7501,
        indicatorHTMLTableRef: null,
        chartRef: "17292440038367",
        indicatorCode: "mye_16_64_males*dr",
        indicatorDate: "2022-06-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 2,
        y_label: "16-64",
        indicatorName: "Male population aged 16 to 64",
        source: "Office for National Statistics (ONS)",
        date: "2022-06-01",
        decimalPlaces: 2,
        dateCoverageText: "2022",
      },
      {
        id: 7499,
        indicatorHTMLTableRef: null,
        chartRef: "17292440038367",
        indicatorCode: "mye_65plus_females*dr",
        indicatorDate: "2022-06-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 3,
        y_label: "65++",
        indicatorName: "Female population aged 65 and over",
        source: "Office for National Statistics (ONS)",
        date: "2022-06-01",
        decimalPlaces: 2,
        dateCoverageText: "2022",
      },
      {
        id: 7500,
        indicatorHTMLTableRef: null,
        chartRef: "17292440038367",
        indicatorCode: "mye_65plus_males*dr",
        indicatorDate: "2022-06-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 4,
        y_label: "65++",
        indicatorName: "Male population aged 65 and over",
        source: "Office for National Statistics (ONS)",
        date: "2022-06-01",
        decimalPlaces: 2,
        dateCoverageText: "2022",
      },
    ],
  },
];

const comparatorAreaCodes = ["CSTM5160", "E10000012", "E10000011"];

const comparatorsList = [
  { area_code: "CSTM5160", area_name: "Brighton and Hove" },
  { area_code: "E10000012", area_name: "Essex" },
  { area_code: "E10000011", area_name: "East Sussex" },
];

const indicatorValues = {
  "CSTM5160.mye_16_64_females*dr.2022-06-01.Female population aged 16 to 64":
    "100,222",
  "E10000012.mye_16_64_females*dr.2022-06-01.Female population aged 16 to 64":
    "18,204,953",
  "E10000011.mye_16_64_females*dr.2022-06-01.Female population aged 16 to 64":
    "2,933,379",
  "CSTM5160.mye_16_64_males*dr.2022-06-01.Male population aged 16 to 64":
    "96,885",
  "E10000012.mye_16_64_males*dr.2022-06-01.Male population aged 16 to 64":
    "17,696,258",
  "E10000011.mye_16_64_males*dr.2022-06-01.Male population aged 16 to 64":
    "2,854,079",
  "CSTM5160.mye_65plus_females*dr.2022-06-01.Female population aged 65 and over":
    "21,465",
  "E10000012.mye_65plus_females*dr.2022-06-01.Female population aged 65 and over":
    "5,756,066",
  "E10000011.mye_65plus_females*dr.2022-06-01.Female population aged 65 and over":
    "1,005,926",
  "CSTM5160.mye_65plus_males*dr.2022-06-01.Male population aged 65 and over":
    "18,053",
  "E10000012.mye_65plus_males*dr.2022-06-01.Male population aged 65 and over":
    "4,873,801",
  "E10000011.mye_65plus_males*dr.2022-06-01.Male population aged 65 and over":
    "841,069",
  "CSTM5160.mye_16_64_females*dr.2022-06-01.Female population aged 16 to 64.rate":
    "36.06%", //xx f
  "E10000012.mye_16_64_females*dr.2022-06-01.Female population aged 16 to 64.rate":
    "31.88%",
  "E10000011.mye_16_64_females*dr.2022-06-01.Female population aged 16 to 64.rate":
    "31.27%",
  "CSTM5160.mye_16_64_males*dr.2022-06-01.Male population aged 16 to 64.rate":
    "34.86%", //xx m
  "E10000012.mye_16_64_males*dr.2022-06-01.Male population aged 16 to 64.rate":
    "30.99%",
  "E10000011.mye_16_64_males*dr.2022-06-01.Male population aged 16 to 64.rate":
    "30.43%",
  "CSTM5160.mye_65plus_females*dr.2022-06-01.Female population aged 65 and over.rate":
    "7.72%", //xx f
  "E10000012.mye_65plus_females*dr.2022-06-01.Female population aged 65 and over.rate":
    "10.08%",
  "E10000011.mye_65plus_females*dr.2022-06-01.Female population aged 65 and over.rate":
    "10.72%",
  "CSTM5160.mye_65plus_males*dr.2022-06-01.Male population aged 65 and over.rate":
    "6.49%", //xx m
  "E10000012.mye_65plus_males*dr.2022-06-01.Male population aged 65 and over.rate":
    "8.53%",
  "E10000011.mye_65plus_males*dr.2022-06-01.Male population aged 65 and over.rate":
    "8.97%",
};

export default {
  reportTheme,
  items,
  indicatorValues,
  comparatorsList,
  comparatorAreaCodes,
};
